import { STATION_UNIT_CONSUMPTION } from 'actions/dataReport';

const initialState = {
  isLoading: false,
  stationUnitConsumptions: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const stationUnitConsumptionReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case STATION_UNIT_CONSUMPTION.REQUEST: {
      return { ...state, isLoading: true };
    }
    case STATION_UNIT_CONSUMPTION.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        stationUnitConsumptions: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case STATION_UNIT_CONSUMPTION.FAIL: {
      return { ...state, isLoading: false };
    }
    default:
      return { ...state };
  }
};
export default stationUnitConsumptionReducer;
